import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'; 
const SERVER_URL = process.env.NODE_ENV === 'production' ? 
  '/' :
  '';

Vue.use(Vuex);

// Первичная настройка модуля - авторизованный пользователь (при загрузке SPA)
const localAuthToken = localStorage.getItem('authToken');
let localCustomerId = null;
if (localAuthToken) {
  axios.defaults.headers.common['authToken'] = localAuthToken;
  localCustomerId = localStorage.getItem('customerId'); 
}

export default new Vuex.Store({
  modules: {
   
  },

  state: {
    host: window.location.hostname == 'localhost' ? 'remont-otdelka-72.ru' : window.location.hostname,
    globalMessages: [],
    localCustomerId: localCustomerId,
    customer: null,
    estimates: [], // Все сметы Клиента
    curPrice: null, // Прайс-лист
    curEstimate: null, // Текущая загруженная Смета
    curCalc: null, // Текущий статус Конструктора сметы
    loading: {
      file: 0,
      loginSendSms: 0,
      loginCheckCode: 0,
      customerInfo: 0,
      price: 0,
      estimateList: 0,
      estimateSingle: 0,
      estimateCreate: 0,
    }
  },

  getters: {
    loadingFiles: state => state.loading.files != 0,
    loadingLoginSendSms: state => state.loading.loginSendSms != 0,
    loadingLoginCheckCode: state => state.loading.loginCheckCode != 0,
    loadingCustomerInfo: state => state.loading.customerInfo != 0,
    loadingEstimates: state => state.loading.estimateList != 0
  },

  mutations: {
    ADD_MESSAGE(state, message) {
      state.globalMessages = [message, ...state.globalMessages];
    },
    POP_MESSAGE(state) {
      if (state.globalMessages.length > 0) state.globalMessages.pop();
    },
    SET_AUTH_DATA(state, customerId ) {
      state.localCustomerId = customerId;
    },
    SET_CUSTOMER_DATA(state, customer) {
      state.customer = customer;
    },
    SET_LOADING_STATUS(state, action) {
      state.loading[action]++;
    },
    REMOVE_LOADING_STATUS(state, action) {
      state.loading[action]--;
    },
    SET_PRICE(state, price) {
      state.curPrice = price;
    },
    SET_ESTIMATE_LIST(state, estimates) {
      state.estimates = estimates;
    },
    SET_SINGLE_ESTIMATE(state, estimate) {
      state.curEstimate = estimate;
    },
    SET_CALC(state, calc) {
      state.curCalc = calc;
    },
  },

  actions: {
    showMessage({ state, commit }, message) {
      if (!state.globalMessages.find(x => x == message)) {
        commit('ADD_MESSAGE', message);
      }
    },

    async loadFile({ commit }, file) {
      commit('SET_LOADING_STATUS', 'file');
      try {
        let formData = new FormData();
        formData.append('file', file, file.name);
        let res = await axios.put(SERVER_URL + 'api/files/', formData, { timeout: 25000 });
        return res.data;
      } catch(err) {
        throw err.response.data;
      } finally {
       commit('REMOVE_LOADING_STATUS', 'file'); 
      }
    },

    // Авторизация в приложении - шаг №1
    async loginSendSms({ commit, state }, phoneNumber) {
      commit('SET_LOADING_STATUS', 'loginSendSms');
      commit('SET_AUTH_DATA', null);
      localStorage.removeItem('authToken');
      localStorage.removeItem('customerId');
      axios.defaults.headers.common['authToken'] = null;

      try {
        let res = await axios.post(SERVER_URL + 'api/customers/login-send-sms/' + state.host, { phoneNumber });
        if (res.data && res.data.siteMarks) {
          //console.log(res.data.siteMarks);
          if (res.data.newCustomer) {
            try {
              ym(res.data.siteMarks.yaMetrika, 'reachGoal', 'lead');
            } catch {
            }
          }
        }
        return res.data;
      } catch(err) {
        //alert(1);
        throw err.response.data;
      } finally {
        commit('REMOVE_LOADING_STATUS', 'loginSendSms');
      }
    },

    // Авторизация в приложении - шаг №2
    async loginCheckCode({ commit, state, dispatch }, { phoneNumber, code }) {
      commit('SET_LOADING_STATUS', 'loginCheckCode');
      try {
        let res = await axios.post(SERVER_URL + 'api/customers/login-check-code/' + state.host, { phoneNumber, code });
        commit('SET_AUTH_DATA', res.data.customerId);

        localStorage.setItem('authToken', res.data.authToken);
        localStorage.setItem('customerId', res.data.customerId);
        axios.defaults.headers.common['authToken'] = res.data.authToken;
        await dispatch('loadCustomerInfo');

        return res.data;
      } catch(err) {
        //alert(1);
        throw err.response.data;
      } finally {
        commit('REMOVE_LOADING_STATUS', 'loginCheckCode');
      }
    },

    // Выход из приложения
    logout({ commit }) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('customerId');
      axios.defaults.headers.common['authToken'] = null;
      commit('SET_AUTH_DATA', null);
    },

    async loadCustomerInfo({ commit, state }) {
      if (state.localCustomerId) {
        commit('SET_LOADING_STATUS', 'customerInfo');
        try {
          let customer = (await axios.get(SERVER_URL + 'api/customers/info')).data;
          commit('SET_CUSTOMER_DATA', customer);
        } catch(err) {
          throw err.response.data;
        } finally {
          commit('REMOVE_LOADING_STATUS', 'customerInfo');
        }
      }
    },

    // Загрузка прайс-листа по городу Клиента
    async loadPrice({commit}) {
      commit('SET_LOADING_STATUS', 'price');
      try {
        let res = await axios.get(SERVER_URL + 'api/prices/lk');
        commit('SET_PRICE', res.data);
        return {
          message: 'Прайс-лист успешно загружен.'
        }
      } catch(err) {
        throw err.response.data;
      } finally {
       commit('REMOVE_LOADING_STATUS', 'price'); 
      }
    },

    // Загрузка данных в Конструктор из текущей Сметы
    async loadCalc({commit, state}) {
      if (state.curEstimate && state.curEstimate.originalCalcObj) {
        commit('SET_CALC', state.curEstimate.originalCalcObj);
        return {
          message: 'Данные успешно загружены.'
        }
      } else {
        return {
          message: 'Загрузка данных невозможна.'
        }
      } 
    },

    // Загрузка списка смет
    async loadEstimates({ commit }) {
      commit('SET_LOADING_STATUS', 'estimateList');
      try {
        let res = await axios.get(SERVER_URL + 'api/estimates/lk');
        commit('SET_ESTIMATE_LIST', res.data);
        return {
          message: 'Сметы успешно загружены.'
        }
      } catch(err) {
        throw err.response.data;
      } finally {
       commit('REMOVE_LOADING_STATUS', 'estimateList'); 
      }
    },

    // Загрузка одной конкретной сметы (для Просмотра)
    async loadSingleEstimate({commit}, id) {
      commit('SET_LOADING_STATUS', 'estimateSingle');
      try {
        let res = await axios.get(SERVER_URL + 'api/estimates/lk/' + id);
        commit('SET_SINGLE_ESTIMATE', res.data);
        return res.data;
      } catch(err) {
        throw err.response.data;
      } finally {
       commit('REMOVE_LOADING_STATUS', 'estimateSingle'); 
      }
    },

    // Создание новой Сметы (вызывается из Конструктора)
    async createEstimate({commit, dispatch}, estimate) {
      commit('SET_LOADING_STATUS', 'estimateCreate');
      try {
        //console.log(estimate);
        let res = await axios.post(SERVER_URL + 'api/estimates/lk', estimate);
        await dispatch('loadEstimates');
        return res.data.id;
      } catch(err) {
        console.log(err);
        throw err.response.data;
      } finally {
       commit('REMOVE_LOADING_STATUS', 'estimateCreate'); 
      }
    },
  },
})
